export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/index.vue'),
    /* no children */
  },
  {
    path: '/:id(.*)',
    /* internal name: '/[...id]' */
    /* no component */
    children: [
      {
        path: '',
        name: '/[...id]/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/[...id]/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/aff-terms',
    /* internal name: '/aff-terms' */
    /* no component */
    children: [
      {
        path: '',
        name: '/aff-terms/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/aff-terms/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/affiliate',
    /* internal name: '/affiliate' */
    /* no component */
    children: [
      {
        path: '',
        name: '/affiliate/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/affiliate/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/aml-policy',
    /* internal name: '/aml-policy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/aml-policy/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/aml-policy/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/aup-policy',
    /* internal name: '/aup-policy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/aup-policy/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/aup-policy/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/authorize',
    /* internal name: '/authorize' */
    /* no component */
    children: [
      {
        path: '',
        name: '/authorize/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/authorize/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/career',
    /* internal name: '/career' */
    /* no component */
    children: [
      {
        path: '',
        name: '/career/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/career/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/cashier',
    /* internal name: '/cashier' */
    /* no component */
    children: [
      {
        path: '',
        name: '/cashier/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/cashier/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/christmas',
    /* internal name: '/christmas' */
    /* no component */
    children: [
      {
        path: '',
        name: '/christmas/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/christmas/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/collection',
    /* internal name: '/collection' */
    /* no component */
    children: [
      {
        path: ':giftCardId',
        name: '/collection/[giftCardId]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/collection/[giftCardId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/collections',
    /* internal name: '/collections' */
    /* no component */
    children: [
      {
        path: '',
        name: '/collections/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/collections/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/contact-us',
    /* internal name: '/contact-us' */
    /* no component */
    children: [
      {
        path: '',
        name: '/contact-us/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/contact-us/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/copyright-policy',
    /* internal name: '/copyright-policy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/copyright-policy/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/copyright-policy/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/error',
    name: '/error',
    component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/error.vue'),
    /* no children */
  },
  {
    path: '/fc25',
    /* internal name: '/fc25' */
    /* no component */
    children: [
      {
        path: 'cheapest-fc-players',
        name: '/fc25/cheapest-fc-players',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc25/cheapest-fc-players.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/fc26',
    /* internal name: '/fc26' */
    /* no component */
    children: [
      {
        path: '',
        name: '/fc26/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc26/index.vue'),
        /* no children */
      },
      {
        path: 'fc26-boosting',
        name: '/fc26/fc26-boosting',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc26/fc26-boosting.vue'),
        /* no children */
      },
      {
        path: 'fc26-coins',
        /* internal name: '/fc26/fc26-coins' */
        /* no component */
        children: [
          {
            path: '',
            name: '/fc26/fc26-coins/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc26/fc26-coins/index.vue'),
            /* no children */
          },
          {
            path: ':path',
            name: '/fc26/fc26-coins/[path]',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc26/fc26-coins/[path].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'fc26-players',
        /* internal name: '/fc26/fc26-players' */
        /* no component */
        children: [
          {
            path: '',
            name: '/fc26/fc26-players/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc26/fc26-players/index.vue'),
            /* no children */
          },
          {
            path: ':path',
            name: '/fc26/fc26-players/[path]',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc26/fc26-players/[path].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'fc26-squad',
        name: '/fc26/fc26-squad',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc26/fc26-squad.vue'),
        /* no children */
      },
      {
        path: 'key',
        name: '/fc26/key',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc26/key.vue'),
        /* no children */
      },
      {
        path: 'points',
        name: '/fc26/points',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fc26/points.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/fortnite',
    /* internal name: '/fortnite' */
    /* no component */
    children: [
      {
        path: 'v-bucks-card',
        /* internal name: '/fortnite/v-bucks-card' */
        /* no component */
        children: [
          {
            path: '',
            name: '/fortnite/v-bucks-card/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/fortnite/v-bucks-card/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/free-fifa-coins',
    /* internal name: '/free-fifa-coins' */
    /* no component */
    children: [
      {
        path: '',
        name: '/free-fifa-coins/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/free-fifa-coins/index.vue'),
        /* no children */
      },
      {
        path: 'countdown',
        name: '/free-fifa-coins/countdown',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/free-fifa-coins/countdown.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/free-fire',
    /* internal name: '/free-fire' */
    /* no component */
    children: [
      {
        path: 'diamonds-pins',
        /* internal name: '/free-fire/diamonds-pins' */
        /* no component */
        children: [
          {
            path: '',
            name: '/free-fire/diamonds-pins/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/free-fire/diamonds-pins/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/free-robux',
    /* internal name: '/free-robux' */
    /* no component */
    children: [
      {
        path: '',
        name: '/free-robux/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/free-robux/index.vue'),
        /* no children */
      },
      {
        path: 'dialog',
        name: '/free-robux/dialog',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/free-robux/dialog.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/game-index',
    /* internal name: '/game-index' */
    /* no component */
    children: [
      {
        path: '',
        name: '/game-index/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/game-index/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/game-points',
    /* internal name: '/game-points' */
    /* no component */
    children: [
      {
        path: '',
        name: '/game-points/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/game-points/index.vue'),
        /* no children */
      },
      {
        path: ':giftCardId',
        name: '/game-points/[giftCardId]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/game-points/[giftCardId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/games',
    /* internal name: '/games' */
    /* no component */
    children: [
      {
        path: '',
        name: '/games/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/games/index.vue'),
        /* no children */
      },
      {
        path: ':giftCardId',
        name: '/games/[giftCardId]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/games/[giftCardId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/gift-cards',
    /* internal name: '/gift-cards' */
    /* no component */
    children: [
      {
        path: '',
        name: '/gift-cards/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/gift-cards/index.vue'),
        /* no children */
      },
      {
        path: ':giftCardId',
        name: '/gift-cards/[giftCardId]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/gift-cards/[giftCardId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/giveaway',
    /* internal name: '/giveaway' */
    /* no component */
    children: [
      {
        path: '',
        name: '/giveaway/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/giveaway/index.vue'),
        /* no children */
      },
      {
        path: 'dialog',
        name: '/giveaway/dialog',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/giveaway/dialog.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/grow-a-garden',
    /* internal name: '/grow-a-garden' */
    /* no component */
    children: [
      {
        path: 'pet-values',
        name: '/grow-a-garden/pet-values',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/grow-a-garden/pet-values.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/help-center',
    /* internal name: '/help-center' */
    /* no component */
    children: [
      {
        path: '',
        name: '/help-center/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/help-center/index.vue'),
        /* no children */
      },
      {
        path: ':artice',
        /* internal name: '/help-center/[artice]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/help-center/[artice]/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/help-center/[artice]/index.vue'),
            /* no children */
          },
          {
            path: ':content',
            name: '/help-center/[artice]/[content]',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/help-center/[artice]/[content].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'search',
        name: '/help-center/search',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/help-center/search.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/home-page-search',
    /* internal name: '/home-page-search' */
    /* no component */
    children: [
      {
        path: 'result',
        name: '/home-page-search/result',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/home-page-search/result.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/honkai-star-rail',
    /* internal name: '/honkai-star-rail' */
    /* no component */
    children: [
      {
        path: 'promotions',
        /* internal name: '/honkai-star-rail/promotions' */
        /* no component */
        children: [
          {
            path: '',
            name: '/honkai-star-rail/promotions/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/honkai-star-rail/promotions/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/how-to-buy',
    /* internal name: '/how-to-buy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/how-to-buy/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/how-to-buy/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/icon',
    name: '/icon',
    component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/icon.vue'),
    /* no children */
  },
  {
    path: '/influncer-content-promo',
    /* internal name: '/influncer-content-promo' */
    /* no component */
    children: [
      {
        path: '',
        name: '/influncer-content-promo/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/influncer-content-promo/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/login',
    /* internal name: '/login' */
    /* no component */
    children: [
      {
        path: '',
        name: '/login/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/login/index.vue'),
        /* no children */
      },
      {
        path: 'forgot-password',
        name: '/login/forgot-password',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/login/forgot-password.vue'),
        /* no children */
      },
      {
        path: 'forgot-password-success',
        name: '/login/forgot-password-success',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/login/forgot-password-success.vue'),
        /* no children */
      },
      {
        path: 'reset-password',
        name: '/login/reset-password',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/login/reset-password.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/member',
    /* internal name: '/member' */
    /* no component */
    children: [
      {
        path: 'affiliate',
        /* internal name: '/member/affiliate' */
        /* no component */
        children: [
          {
            path: 'paid-tasks',
            name: '/member/affiliate/paid-tasks',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/affiliate/paid-tasks.vue'),
            /* no children */
          },
          {
            path: 'promotion-management',
            name: '/member/affiliate/promotion-management',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/affiliate/promotion-management.vue'),
            /* no children */
          },
          {
            path: 'promotion-material',
            name: '/member/affiliate/promotion-material',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/affiliate/promotion-material.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'api',
        /* internal name: '/member/api' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/api/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/api/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'blacklist',
        /* internal name: '/member/blacklist' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/blacklist/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/blacklist/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'buyer-order',
        /* internal name: '/member/buyer-order' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/buyer-order/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/buyer-order/index.vue'),
            /* no children */
          },
          {
            path: 'details',
            name: '/member/buyer-order/details',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/buyer-order/details.vue'),
            /* no children */
          },
          {
            path: 'dispute',
            name: '/member/buyer-order/dispute',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/buyer-order/dispute.vue'),
            /* no children */
          },
          {
            path: 'get-coins',
            name: '/member/buyer-order/get-coins',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/buyer-order/get-coins.vue'),
            /* no children */
          },
          {
            path: 'get-items',
            name: '/member/buyer-order/get-items',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/buyer-order/get-items.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'chat',
        /* internal name: '/member/chat' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/chat/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/chat/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'coupon',
        /* internal name: '/member/coupon' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/coupon/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/coupon/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'credits-mall',
        /* internal name: '/member/credits-mall' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/credits-mall/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/credits-mall/index.vue'),
            /* no children */
          },
          {
            path: 'detail',
            name: '/member/credits-mall/detail',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/credits-mall/detail.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'deposit',
        /* internal name: '/member/deposit' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/deposit/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/deposit/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'notification',
        /* internal name: '/member/notification' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/notification/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/notification/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'offers',
        /* internal name: '/member/offers' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/offers/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/offers/index.vue'),
            /* no children */
          },
          {
            path: 'create-offer',
            name: '/member/offers/create-offer',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/offers/create-offer.vue'),
            /* no children */
          },
          {
            path: 'edit-digital-product-offer',
            name: '/member/offers/edit-digital-product-offer',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/offers/edit-digital-product-offer.vue'),
            /* no children */
          },
          {
            path: 'edit-game-service-offer',
            name: '/member/offers/edit-game-service-offer',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/offers/edit-game-service-offer.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'seller-application',
        /* internal name: '/member/seller-application' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/seller-application/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/seller-application/index.vue'),
            /* no children */
          },
          {
            path: 'account-selection',
            name: '/member/seller-application/account-selection',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/seller-application/account-selection.vue'),
            /* no children */
          },
          {
            path: 'application-status',
            name: '/member/seller-application/application-status',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/seller-application/application-status.vue'),
            /* no children */
          },
          {
            path: 'email-verification',
            name: '/member/seller-application/email-verification',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/seller-application/email-verification.vue'),
            /* no children */
          },
          {
            path: 'enterprise-seller-steps',
            name: '/member/seller-application/enterprise-seller-steps',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/seller-application/enterprise-seller-steps.vue'),
            /* no children */
          },
          {
            path: 'individual-seller-steps',
            name: '/member/seller-application/individual-seller-steps',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/seller-application/individual-seller-steps.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'setting',
        /* internal name: '/member/setting' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/setting/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/index.vue'),
            /* no children */
          },
          {
            path: 'affiliate-center',
            name: '/member/setting/affiliate-center',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/affiliate-center.vue'),
            /* no children */
          },
          {
            path: 'personal-affiliate',
            name: '/member/setting/personal-affiliate',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-affiliate.vue'),
            /* no children */
          },
          {
            path: 'personal-center',
            name: '/member/setting/personal-center',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-center.vue'),
            /* no children */
          },
          {
            path: 'personal-history',
            name: '/member/setting/personal-history',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-history.vue'),
            /* no children */
          },
          {
            path: 'personal-information',
            name: '/member/setting/personal-information',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-information.vue'),
            /* no children */
          },
          {
            path: 'personal-media',
            name: '/member/setting/personal-media',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-media.vue'),
            /* no children */
          },
          {
            path: 'personal-notification',
            name: '/member/setting/personal-notification',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-notification.vue'),
            /* no children */
          },
          {
            path: 'personal-password',
            name: '/member/setting/personal-password',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-password.vue'),
            /* no children */
          },
          {
            path: 'personal-security',
            name: '/member/setting/personal-security',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-security.vue'),
            /* no children */
          },
          {
            path: 'personal-setting',
            name: '/member/setting/personal-setting',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-setting.vue'),
            /* no children */
          },
          {
            path: 'personal-two-step',
            name: '/member/setting/personal-two-step',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/personal-two-step.vue'),
            /* no children */
          },
          {
            path: 'seller-center',
            name: '/member/setting/seller-center',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/setting/seller-center.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sold-order',
        /* internal name: '/member/sold-order' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/sold-order/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/sold-order/index.vue'),
            /* no children */
          },
          {
            path: 'details',
            name: '/member/sold-order/details',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/sold-order/details.vue'),
            /* no children */
          },
          {
            path: 'dispute',
            name: '/member/sold-order/dispute',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/sold-order/dispute.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'store-setting',
        /* internal name: '/member/store-setting' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/store-setting/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/store-setting/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'verification-transfer',
        /* internal name: '/member/verification-transfer' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/verification-transfer/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/verification-transfer/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'wallet',
        /* internal name: '/member/wallet' */
        /* no component */
        children: [
          {
            path: '',
            name: '/member/wallet/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/wallet/index.vue'),
            /* no children */
          },
          {
            path: 'settings',
            name: '/member/wallet/settings',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/wallet/settings.vue'),
            /* no children */
          },
          {
            path: 'withdraw',
            name: '/member/wallet/withdraw',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/member/wallet/withdraw.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/memberAgreement',
    /* internal name: '/memberAgreement' */
    /* no component */
    children: [
      {
        path: '',
        name: '/memberAgreement/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/memberAgreement/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/murder-mystery-2',
    /* internal name: '/murder-mystery-2' */
    /* no component */
    children: [
      {
        path: 'values',
        name: '/murder-mystery-2/values',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/murder-mystery-2/values.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/offer',
    /* internal name: '/offer' */
    /* no component */
    children: [
      {
        path: 'coins-detail',
        name: '/offer/coins-detail',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/offer/coins-detail.vue'),
        /* no children */
      },
      {
        path: 'other-detail',
        name: '/offer/other-detail',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/offer/other-detail.vue'),
        /* no children */
      },
      {
        path: 'squad-:id',
        name: '/offer/squad-[id]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/offer/squad-[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/order',
    /* internal name: '/order' */
    /* no component */
    children: [
      {
        path: ':result',
        name: '/order/[result]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/order/[result].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/privacy',
    /* internal name: '/privacy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/privacy/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/privacy/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/product',
    /* internal name: '/product' */
    /* no component */
    children: [
      {
        path: ':skuUrl',
        name: '/product/[skuUrl]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/product/[skuUrl].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/pubg-mobile',
    /* internal name: '/pubg-mobile' */
    /* no component */
    children: [
      {
        path: 'uc-code',
        /* internal name: '/pubg-mobile/uc-code' */
        /* no component */
        children: [
          {
            path: '',
            name: '/pubg-mobile/uc-code/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/pubg-mobile/uc-code/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/referral',
    /* internal name: '/referral' */
    /* no component */
    children: [
      {
        path: '',
        name: '/referral/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/referral/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/refund-promise',
    /* internal name: '/refund-promise' */
    /* no component */
    children: [
      {
        path: '',
        name: '/refund-promise/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/refund-promise/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/roblox',
    /* internal name: '/roblox' */
    /* no component */
    children: [
      {
        path: 'gift-cards',
        /* internal name: '/roblox/gift-cards' */
        /* no component */
        children: [
          {
            path: '',
            name: '/roblox/gift-cards/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/roblox/gift-cards/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'roblox-robux',
        /* internal name: '/roblox/roblox-robux' */
        /* no component */
        children: [
          {
            path: '',
            name: '/roblox/roblox-robux/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/roblox/roblox-robux/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'robux-tax-calculator',
        /* internal name: '/roblox/robux-tax-calculator' */
        /* no component */
        children: [
          {
            path: '',
            name: '/roblox/robux-tax-calculator/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/roblox/robux-tax-calculator/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/roblox-games',
    /* internal name: '/roblox-games' */
    /* no component */
    children: [
      {
        path: '',
        name: '/roblox-games/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/roblox-games/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/sell',
    /* internal name: '/sell' */
    /* no component */
    children: [
      {
        path: '',
        name: '/sell/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/sell/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/sell-at-u7buy',
    /* internal name: '/sell-at-u7buy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/sell-at-u7buy/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/sell-at-u7buy/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/seller',
    /* internal name: '/seller' */
    /* no component */
    children: [
      {
        path: ':index',
        name: '/seller/[index]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/seller/[index].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/social-community',
    /* internal name: '/social-community' */
    /* no component */
    children: [
      {
        path: '',
        name: '/social-community/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/social-community/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/software',
    /* internal name: '/software' */
    /* no component */
    children: [
      {
        path: '',
        name: '/software/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/software/index.vue'),
        /* no children */
      },
      {
        path: ':giftCardId',
        name: '/software/[giftCardId]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/software/[giftCardId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/steal-a-brainrot',
    /* internal name: '/steal-a-brainrot' */
    /* no component */
    children: [
      {
        path: 'all-brainrots-list',
        name: '/steal-a-brainrot/all-brainrots-list',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/steal-a-brainrot/all-brainrots-list.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/steam',
    /* internal name: '/steam' */
    /* no component */
    children: [
      {
        path: 'gift-cards',
        /* internal name: '/steam/gift-cards' */
        /* no component */
        children: [
          {
            path: '',
            name: '/steam/gift-cards/',
            component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/steam/gift-cards/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/subscriptions',
    /* internal name: '/subscriptions' */
    /* no component */
    children: [
      {
        path: '',
        name: '/subscriptions/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/subscriptions/index.vue'),
        /* no children */
      },
      {
        path: ':giftCardId',
        name: '/subscriptions/[giftCardId]',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/subscriptions/[giftCardId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/terms',
    /* internal name: '/terms' */
    /* no component */
    children: [
      {
        path: '',
        name: '/terms/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/terms/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/transfer-page',
    /* internal name: '/transfer-page' */
    /* no component */
    children: [
      {
        path: '',
        name: '/transfer-page/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/transfer-page/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/ugc',
    /* internal name: '/ugc' */
    /* no component */
    children: [
      {
        path: '',
        name: '/ugc/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/ugc/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/UGC',
    /* internal name: '/UGC' */
    /* no component */
    children: [
      {
        path: '',
        name: '/UGC/',
        component: () => import('/var/lib/jenkins/workspace/u7buy-Frontend-Test/src/views/UGC/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

